import React, { useMemo } from 'react';

import { collectionStyle, MOVE_STRINGS, MOVES, NFT_IMAGES, TierKey } from '../../constants';
import clsx from 'clsx';

import { MovesEnum } from 'shared/constants/shared-enums';
import { useQuestsStore } from 'shared/store/questsStore';

import { Card } from './card';

interface LevelLineProps {
  collection: TierKey;
  onMint: (move: MovesEnum, collection: TierKey) => void;
  onForge: (move: MovesEnum, collection: TierKey) => void;
}

export const LevelLine: React.FC<LevelLineProps> = React.memo(({ collection, onMint, onForge }) => {
  const tierBalances = useQuestsStore((s) => s.nftBalances?.[collection]);
  const images = useMemo(() => {
    const tierImgs = NFT_IMAGES[collection];
    return {
      back: tierImgs.back,
      rock: tierImgs[MovesEnum.Rock],
      paper: tierImgs[MovesEnum.Paper],
      scissors: tierImgs[MovesEnum.Scissors],
    };
  }, [collection]);

  return (
    <>
      <div className="mb-1.5 flex items-center md:mb-4">
        <span aria-hidden={true} className="mr-2.5 h-0.5 flex-1 bg-white/20" />
        <p
          className={clsx(
            `bg-clip-text text-[40px] font-bold uppercase leading-none text-transparent [-webkit-text-fill-color:transparent] [-webkit-text-stroke-width:2px] sm:text-5xl`,
            collectionStyle[collection],
          )}
        >
          {collection}
        </p>
        <span aria-hidden={true} className="h-0.5 flex-1 bg-white/20" />
      </div>

      <div className="mb-1.5 grid w-full grid-cols-[repeat(3,_30%)] justify-between md:mb-4">
        {MOVES.map((move) => {
          const moveKey = MOVE_STRINGS[move];
          const entry = tierBalances?.[move];
          const count = entry?.count ?? 0;

          return (
            <Card
              key={move}
              front={images[moveKey]}
              back={images.back}
              count={count}
              canForge={!!entry?.canForge}
              canMint={!!entry?.canMint}
              open={count > 0}
              openTimeOut={entry?.openTimeOut ?? 0}
              onMint={onMint}
              onForge={onForge}
              move={move}
              collection={collection}
            />
          );
        })}
      </div>
    </>
  );
});
